module.exports = __webpack_public_path__ + "img/sb.dd21fe3c.png";